export default __webpack_public_path__ + "static/media/save_caution_dither.77ecc502.svg";